import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../common/error'

import { Error } from 'components/Error'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ContactInfoErrorHandler: React.FC<ErrorHandlerProps> = ({
  children,
}) => {
  const { t } = useTranslation(['contact'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      return (
        <Error
          title={t('errors.title')}
          message={t('errors.failedToLoadContacts')}
        />
      )
    }

    return (
      <Error
        title={t('errors.title')}
        message={t('errors.failedToLoadContacts')}
      />
    )
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
